import React, { useState, useEffect, useCallback } from "react";
import { Link, useHistory, useParams } from 'react-router-dom'
import { 
    Row, 
    Col,
    Container,
    Nav, 
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button
} from 'reactstrap';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from "react-i18next";

import { useModalsState } from '../../context/modals'
import { EditorProvider, useEditor } from '../../context/editor'

import ContractConfigurationContainer from '../../components/ContractConfiguration';
import MainLayout from '../../layouts/MainLayout';
import { ReactComponent as Step1 } from '../../images/icons/paso-1.svg'
import { ReactComponent as Step2 } from '../../images/icons/paso-2.svg'
import { ReactComponent as Step3 } from '../../images/icons/paso-3.svg'


function CreateContract() {
    const { t } = useTranslation('common')

    return (
        <MainLayout>
            <Container tag="section" className="" fluid >
                <div className="mb-5 d-flex justify-content-center align-items-center">
                    <div className="block-heading-1" data-aos="fade-up" data-aos-delay="">
                        <h2 className="text-center">Contratos al instante</h2>
                        <p className="text-muted">Realiza contratos a la medida, solo sigue estos sencillos pasos.</p>
                    </div>
                </div>
                <Row className="mb-3 justify-content-center">
                    <Col md={5} lg={3} className="bg-light mb-4 py-3 rounded mr-4">
                        <div class="d-flex flex-column align-items-center text-center mb-2">
                            <Step1 width={220} />
                            <span>Paso 1</span>
                        </div>
                        <h5 class="text-center text-black">Selecciona el tipo <br /> de contrato</h5>
                    </Col>
                    <Col md={5} lg={3} className="bg-light mb-4 py-3 rounded mr-4">
                        <div class="d-flex flex-column align-items-center text-center mb-1">
                            <Step2 width={220} />
                            <span class="primary">Paso 2</span>
                        </div>
                        <h5 class="text-center text-black">Elige el tipo de cláusulas <br/> que necesitas</h5>
                    </Col>
                    <Col md={5} lg={3} className="bg-light mb-4 rounded">
                        <div class="d-flex flex-column align-items-center text-center mb-2">
                            <Step3 width={220} />
                        <span>Paso 3</span>
                        </div>
                        <h5 class="text-center text-black">Envíalo a firma a las <br /> partes involucradas</h5>
                    </Col>
                </Row>
                <Row className="mb-4 justify-content-center">
                    <Col className="text-center mb-4" md={8}>
                        <Button
                            color="accent-100"
                            size="md"
                            tag={Link}
                            to='/contracts/create'
                        >
                            Crear contrato
                        </Button>
                    </Col>
                </Row>
                <blockquote class="mb-5 text-muted d-flex justify-content-center" >
                    <p className="mxw-70vw"><span class="font-weight-bold">Disclaimer.</span> behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.”</p>
                </blockquote>
            

            </Container>
        </MainLayout>
    );
}

export default CreateContract;



